import React from 'react';
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';

interface IdenticonProps {
  address: string;
  size?: number;
  className?: string;
}

/**
 * Identicon component that generates a unique icon based on Ethereum address
 * Uses react-jazzicon for consistent visual identity
 */
const Identicon: React.FC<IdenticonProps> = ({ address, size = 24, className }) => {
  if (!address) return null;

  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Jazzicon diameter={size} seed={jsNumberForAddress(address)} />
    </div>
  );
};

export default Identicon;
